export const CHAT_EMOJI_OPTIONS = ['👍', '👏', '✅', '❌', '😂', '😊', '😉', '😢', '🔥', '🙏', '❤️', '👀', '🎉', '💪', '🤔'] as const;

const SMILEY_CODES: Record<string, string> = {
  ':-)': '😊',
  ':)': '😊',
  ':D': '😄',
  ':-D': '😄',
  ';-)': '😉',
  ';)': '😉',
  ':-(': '😢',
  ':(': '😢',
  ':-P': '😛',
  ':P': '😛',
  ':-p': '😛',
  ':p': '😛',
  ':-O': '😮',
  ':O': '😮',
  ':-o': '😮',
  ':o': '😮',
  '<3': '❤️',
  '</3': '💔',
  ':*': '😘',
  ':-*': '😘',
  'XD': '😂',
  'xD': '😂',
  ':\'(': '😢',
  ':\'-)': '😂',
  ':\')': '😂',
  '8-)': '😎',
  '8)': '😎',
  'B-)': '😎',
  'B)': '😎',
  ':-|': '😐',
  ':|': '😐',
  '>:-(': '😠',
  '>:(': '😠',
  ':-/': '😕',
  ':/': '😕',
  'O:-)': '😇',
  'O:)': '😇',
  '3:)': '😈',
  '>:)': '😈',
  ':3': '😺',
  '^_^': '😊',
  '^.^': '😊',
  '-_-': '😑',
  'o_O': '😳',
  'O_o': '😳',
  '(y)': '👍',
  '(n)': '👎',
  '\\o/': '🙌',
};

export function convertSmileyToEmoji(text: string): string {
  let result = text;
  const sortedCodes = Object.keys(SMILEY_CODES).sort((a, b) => b.length - a.length);
  
  for (const code of sortedCodes) {
    const escapedCode = code.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(^|\\s)${escapedCode}(?=\\s|$|[.,!?;:])`, 'g');
    result = result.replace(regex, (match, prefix) => prefix + SMILEY_CODES[code]);
  }
  
  return result;
}
